<template>
  <v-container 
    fluid class="px-10 py-8" 
    :style="{ background: $vuetify.theme.themes.light.background }"
  >
    <p class="text-h4">
      トピック作成
      <span>
        <v-icon 
          small
          color="red darken-2"
          @click="helpPage()"
        >mdi-comment-question-outline</v-icon>
      </span>
    </p>
    <ValidationObserver ref="observer" v-slot="{ invalid }">
      <v-form ref="form" v-on:submit.prevent="">
        <v-row>
          <v-col cols="4">
            <p class="text-h5" style="color:#797884;">メイントピック</p>
            <v-sheet flat rounded class="px-8 py-6">
              <div>
                <ValidationProvider 
                  name="トピック名"
                  rules="required|max:100" 
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="Topic.topic_name"
                    label="このトピックのタイトルを書いてください(必須)"
                    class="pt-0 mt-0 mb-5"
                    single-line
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
              </div>
              <div>
                <ValidationProvider 
                  name="タグ" 
                  rules="required|tagLength" 
                  v-slot="{ errors }"
                >
                  <v-autocomplete
                    v-model="tagSelect"
                    :items="
                      tagList.map(i => ({ value: i.id, text: i.tag_name }))
                    "
                    label="タグを選択してください(必須)"
                    class="pt-0 mt-0 mb-5"
                    single-line
                    chips
                    multiple
                    attach
                    :error-messages="errors"
                  ></v-autocomplete>
                </ValidationProvider>
              </div>
              <div>
                <ValidationProvider 
                  name="トピック説明" 
                  rules="max:255" 
                  v-slot="{ errors }"
                >
                  <v-textarea
                    v-model="Topic.information_text"
                    label="このトピックの説明を書いてください"
                    class="pt-3 mb-0"
                    single-line
                    outlined
                    auto-grow
                    :error-messages="errors"
                  ></v-textarea>
                </ValidationProvider>
              </div>
              <div>
                <ValidationProvider 
                  name="アイコン" 
                  rules="" 
                  v-slot="{ errors }"
                >
                  <v-img
                    class="white--text align-end"
                    style="max-height:302px"
                    :src="ImagePreview"
                  ></v-img>
                  <div class="text-body-2 mt-4">
                    ※JPG、JPEG、PNG形式の画像をアップロードしてください。最大ファイルサイズ: 20MB
                  </div>
                  <div>
                    <a :href="templateImg" style="text-decoration:none; font-size: 14px;" download>
                      テンプレート画像ダウンロード
                    </a>
                  </div>
                  <v-btn
                    class="mr-6"
                    depressed
                    dark
                    color="primary"
                    outlined
                    @click="imageDelete"
                  >キャンセル</v-btn>
                  <span>
                    <v-btn
                      depressed
                      dark
                      color="primary"
                      @click="imageUpload"
                      accept=".jpg, .jpeg, .png"
                      :error-messages="errors"
                    >画像を選択する</v-btn>
                    <input
                      style="display: none"
                      ref="input"
                      type="file"
                      id="inputFile"
                      accept="image/jpeg, image/jpg, image/png"
                      @change="selectedFile()"
                    />
                  </span>
                </ValidationProvider>
              </div>
            </v-sheet>
          </v-col>
          <v-col cols="8" class="text-h5" style="color:#797884;">
            <v-row class="pa-3  d-flex justify-space-between">
              <p class="text-h5" style="color:#797884;">トピックパーツ</p>
            </v-row>
            <v-expansion-panels mandatory>
              <draggable 
                v-bind="options" 
                v-model="Topic.topic_parts"
                handle=".handle"
                style="width:100%; height:100%;"
              >
                <v-expansion-panel
                  v-for="(topicPart, index) in Topic.topic_parts"
                  :key="topicPart.id"
                  style="
                    border-left-style: solid;
                    border-left-color: #8E45D6;
                    border-left-width: 5px;
                  "
                  class="mb-3"
                >
                  <v-sheet
                    flat
                    rounded
                    class="px-4 py-2"
                  >
                    <div class="handle mb-0" style="font-size: 1.2rem; cursor: grab;"><span class="font-weight-bold">{{ index + 1 }}</span></div>
                    <v-expansion-panel-header v-slot="{ open }" class="pt-0">
                      <div v-if="!open">
                        <v-list v-if="topicPart.url !== ''" lines="one" >
                          <v-list-item-title>
                            {{ topicPart.url }}
                          </v-list-item-title>
                          <v-list-item-subtitle class="mt-4">
                            {{ topicPart.title }}
                          </v-list-item-subtitle>
                        </v-list>
                        <v-list v-else>
                          <v-list-item-title class="text-subtitle-1 mb-0 pb-0 pink--text lighten-2 font-weight-bold">
                            https:// URLを入力してください
                          </v-list-item-title>
                        </v-list>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div>
                        <ValidationProvider 
                          name="URL" 
                          rules="required_with:@title|max:500|url"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="topicPart.url"
                            label="共有したいURLを入力してください"
                            class="pt-0 mt-0 mb-5"
                            single-line
                            :error-messages="errors"
                          ></v-text-field>
                        </ValidationProvider>
                      </div>
                      <div>
                        <ValidationProvider 
                          name="トピックパーツ名" 
                          rules="max:300"
                          v-slot="{ errors }"
                          vid="title"
                        >
                          <v-text-field
                            v-model="topicPart.title"
                            label="このトピックパーツのタイトルを書いてください"
                            class="pt-0 mt-0 mb-5"
                            single-line
                            :error-messages="errors"
                          ></v-text-field>
                        </ValidationProvider>
                      </div>
                      <div>
                        <ValidationProvider 
                          name="トピックパーツ説明" 
                          rules="max:100000" 
                          v-slot="{ errors }"
                        >
                          <mavon-editor
                            :toolbars="markdownOption"
                            language="ja"
                            defaultOpen="edit"
                            v-model="topicPart.information_text"
                            placeholder="このトピックパーツの説明を書いてください"
                            class="pt-3 mb-0"
                            single-line
                            outlined
                            auto-grow
                            style="height: 420px"
                            previewBackground="#333333"
                            codeStyle='a11y-dark'
                            @imgAdd="imgAdd"
                            :xssOptions="{
                              whiteList: {
                                iframe: ['src', 'height', 'width'],
                                div: ['style', 'height', 'width', 'align']
                              }
                            }"
                            :error-messages="errors"
                          />
                        </ValidationProvider>
                      </div>
                      <v-row v-if="Topic.topic_parts.length > 1">
                        <v-btn
                          depressed
                          outlined
                          large
                          color="#FF7171"
                          class="ml-auto mx-3 mt-12"
                          @click="removeInput(topicPart.id)"
                          >削除する</v-btn>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-sheet>
                </v-expansion-panel>
              </draggable>
            </v-expansion-panels>
          </v-col>
        </v-row>
        <v-row class="mt-0 mb-8 mr-0" justify="end">
          <div>
            <v-btn
            depressed
            color="#FFFFFF"
            class="textColor--text mr-4 d-none d-sm-inline"
            style="border-style: solid; border-color: #C388FF;"
            @click="openBookmarkModal()"
          >ブックマークから作成</v-btn>
          <v-btn
            depressed
            color="#FFFFFF"
            class="textColor--text ml-auto"
            style="border-style: solid; border-color: #C388FF;"
            @click="addInput()"
          >トピックパーツ追加</v-btn>
          </div>
        </v-row>
        <v-row justify="end" class="px-3">
          <ValidationProvider name="権限設定" rules="required" v-slot="{ errors }">
            <v-select
              class="select-input-none pr-6 text-lg-center"
              v-model="selectType"
              :items="topicType"
              :menu-props="{ top: true, offsetY: true }"
              label="権限設定"
              item-text="label"
              item-value="value"
              item-color="black"
              outlined
              dense
              height="42px"
              color="#C388FF"
              return-object
              single-line
              :error-messages="errors"
            ></v-select>
          </ValidationProvider>
          <v-btn 
            width="200" 
            color="#5E00BC" 
            class="white--text font-weight-bold" 
            height="42px"
            large 
            @click="create" 
            :disabled="invalid" 
            v-if="noLoading"
          >作成する</v-btn>
          <v-btn 
            width="200"
            color="#5E00BC"
            class="white--text font-weight-bold"
            large
            disabled
            v-else
          >作成する</v-btn>
        </v-row>
      </v-form>
    </ValidationObserver>
    <BookmarkModal 
      :isOpenBookmarkModal="isOpenBookmarkModal"
      :isCloseBookmarkModal="closeBookmarkModal"
      :addInput="addInput"
      :topic="Topic"
    />
  </v-container>
</template>
<style scoped>
.text-subtitle-1 {
  width: 60%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
<script>
import VueMarkdown from 'vue-markdown'
import draggable from "vuedraggable"
import BookmarkModal from '../organisms/BookmarkModal.vue'
import imageCompression from 'browser-image-compression'

export default {
  name: "TopicCreate",
  components: {
    VueMarkdown,
    draggable,
    BookmarkModal,
  },
  data() {
    return {
      Topic: {
        topic_name: '',
        information_text: null,
        topic_type: '',
        is_draft: false,
        is_released: false,
        tags: [],
        topic_parts: [
          { id: 1, title: '', url: '', information_text: '', order : 1 },
        ],
      },
      noLoading: true,
      preview: process.env.VUE_APP_IMAGE_BUCKET_URL + '/topic_image/default_topic_image.svg',
      image: '',
      tagList: [],
      tagSelect: [],
      markdownOption: {
        bold: true,
        italic: true,
        header: true,
        underline: true,
        strikethrough: true,
        mark: false,
        superscript: false,
        subscript: false,
        quote: true,
        ol: true,
        ul: true,
        link: true,
        imagelink: true,
        code: true,
        table: true,
        fullscreen: false,
        readmodel: true,
        htmlcode: false,
        help: false,
        undo: true,
        redo: false,
        trash: false,
        save: false,
        navigation: false,
        alignleft: false,
        aligncenter: false,
        alignright: false,
        subfield: false,
        preview: true
      },
      options: {
        animation: 400
      },
      isExpand: [0],
      selectType: "",
      topicType: [
        { label: '公開', value: 'general'},
        { label: 'リンクを知っている人のみ参照', value: 'group_only_read'},
        { label: 'リンクを知っている人のみ編集', value: 'group_only_write'},
        { label: '自分のみ', value: 'personal'},
        { label: '下書き', value: 'draft'},
      ],
      isOpenBookmarkModal: false,
      templateImg: require("@/assets/template.png"),
    }
  },
  computed: {
    ImagePreview() {
      return this.preview;
    },
  },
  methods: {
    lastTopicParts() {
      return this.Topic.topic_parts.pop();
    },
    addInput(bookmarkTitle = '', bookmarkUrl = ''){
      let topicPart = this.Topic.topic_parts
      topicPart.push({
        id: this.Topic.topic_parts.length + 1,
        title: bookmarkTitle,
        url: bookmarkUrl,
        information_text: '',
        order: this.Topic.topic_parts.length + 1,
      })
      let tagBox = [];
      if(this.tagSelect) {
        this.tagSelect.forEach(function(tag){
          let data = { tag_id: tag };
          tagBox.push(data)
        });
      }
    },
    removeInput (id) {
      let newTopicParts = this.Topic.topic_parts.filter(input => input.id !== id)
      if(newTopicParts.length){
        for(let i = 0; i < newTopicParts.length; i++) {
          newTopicParts[i].id = i + 1
          newTopicParts[i].order = i + 1
        }
        this.Topic.topic_parts = newTopicParts
      }
    },
    create() {
      this.noLoading = false;
      this.Topic.topic_type = this.selectType.value;
      let tagBox = [];
      if(this.tagSelect) {
        this.tagSelect.forEach(function(tag){
          let data = { tag_id: tag };
          tagBox.push(data)
        });
      }
      this.Topic.tags = tagBox;
      if (this.Topic.topic_type === 'personal') {
        this.Topic.is_released = true;
      }
      if (this.Topic.topic_type === 'draft') {
        this.Topic.topic_type = 'personal';
        this.Topic.is_draft = true;
      }
      this.$axios.post(process.env.VUE_APP_API_BASE_URL + '/topic/', this.Topic)
        .then(response => {
          // 画像作成API
          if (this.image) {
            this.$axios.post(process.env.VUE_APP_API_BASE_URL + '/topic_image_upload/' + response.data.id, this.image, {
              headers: { 'content-type': 'multipart/form-data' }
            })
          }
          setTimeout(function() {
            this.$router.push('/user/' + this.$store.getters['auth/isUserCode']);
          }.bind(this), 2000);
        });
    },
    imageUpload() {
      this.$refs.input.click();
    },
    async selectedFile() {
      this.isUploading = true;

      let file = this.$refs.input.files[0];
      if (!file) {
        return;
      }
      let size = file.size;
      let type = file.type;
      let errors = '';
      //上限サイズ20MB
      if (size > 20000000) {
        errors += 'ファイルの上限サイズ20MBを超えています\n'
      }
      //拡張子は .jpg .png .jpg のみ許可
      if (type != 'image/jpeg' && type != 'image/png' && type != 'image/jpg') {
        errors += '.jpg、.png、.jpgのいずれかのファイルのみ許可されています\n'
      }
      // 画像のトリミング
      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1024,
        useWebWorker: true
      }
      try {
        file = await imageCompression(file, options);
      } catch (error) {
        console.log(error);
      }
      this.preview = URL.createObjectURL(file)
      const data = new FormData()
      data.append('image', file)
      this.image = data
      if (errors) {
        //errorsが存在する場合は内容をalert
        this.$swal('エラー', errors, 'error')
        //valueを空にしてリセットする
        this.image = null;
        this.preview = process.env.VUE_APP_IMAGE_BUCKET_URL + '/topic_image/default_topic_image.svg';
      }
    },
    imageDelete() {
      this.preview = process.env.VUE_APP_IMAGE_BUCKET_URL + '/topic_image/default_topic_image.svg';
      document.getElementById('inputFile').value = ''
      if (this.image) {
        this.image = null
      }
    },
    openBookmarkModal() {
      this.isOpenBookmarkModal = true;
    },
    closeBookmarkModal() {
      this.isOpenBookmarkModal = false;
    },
    helpPage() {
      let next = this.$router.resolve({
        name: 'help',
      });
      window.open(next.href, '_blank');
    },
    imgAdd(fileName, file) { // 非同期画像登録
      let data = new FormData();
      data.append('image', file);
      let imageData = data;
      this.$axios.post(process.env.VUE_APP_API_BASE_URL + '/topic_parts_image_upload/', imageData, {headers: { "content-type": "multipart/form-data" }})
        .then(response => {
          let regex = '![' + file._name + '](' + fileName + ')';
          let nextUrl = '![' + file._name + '](' + process.env.VUE_APP_IMAGE_BUCKET_URL + response.data.file_path + ')';
          this.Topic.topic_parts.map((topicPart, index) => {
            this.Topic.topic_parts[index].information_text = topicPart.information_text.replace(regex, nextUrl);
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
  created: async function () {
    await this.$axios.get(process.env.VUE_APP_API_BASE_URL + '/tag')
      .then(response=> {
        this.tagList = response.data;
      });
  },
};
</script>
<style src="../../styles/sample.css" scoped>
</style>
